// Web push registration helper for ChambaNow
import axios from "axios";
import { API } from "@/AppContext";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch (e) {
    console.warn("SW registration failed", e);
    return null;
  }
}

export async function ensurePushSubscription(authHeaders) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return { ok: false, reason: "unsupported" };
  if (Notification.permission === "denied") return { ok: false, reason: "denied" };

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    if (Notification.permission !== "granted") {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return { ok: false, reason: "denied" };
    }
    const r = await axios.get(`${API}/push/vapid-public-key`);
    const key = r.data.public_key;
    if (!key) return { ok: false, reason: "no_vapid_key" };
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  const payload = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, {
    endpoint: payload.endpoint,
    keys: payload.keys,
  }, { headers: authHeaders() });
  return { ok: true };
}
